import React from "react";
import { slide as Menu } from "react-burger-menu";
import TendersClubLogo from "../../Components/tendersClubLogo";
import { useAuth } from "../../Services/auth";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SidebarContext } from "../sidebarContext";
import AwardsSearchDropdown from "./awardsSearchDropdown";
import TendersDropdown from "./tendersDropdown";
import { useAuthStore } from "../../Stores/authStore";
import i18n from "../../i18n";

export default function Navigation({ sidebar }) {
  const auth = useAuth();
  const ctx = React.useContext(SidebarContext);
  let authenticated = false;
  if (useAuthStore.getState()?.user?.email) {
    authenticated = true;
  }

  return sidebar ? (
    <Menu
      right
      customBurgerIcon={false}
      isOpen={ctx.isMenuOpen}
      onStateChange={(state) => ctx.stateChangeHandler(state)}
      width={320}
    >
      <div className="d-flex flex-column tc-flex-gap-10px">
        <NavLinks sidebar={sidebar} ctx={ctx} authenticated={authenticated} auth={auth} />
        {authenticated ? <AwardsSearchDropdown sidebar={sidebar} ctx={ctx} /> : null}
      </div>
    </Menu>
  ) : (
    <div className={`tc-horizontal-nav ${i18n.language.slice(0, 2)} ${authenticated ? "authenticated" : "w-full"}`}>
      <NavLinks sidebar={sidebar} ctx={ctx} authenticated={authenticated} auth={auth} />
    </div>
  );
}

export const shortenItem = (item, sidebar) => {
  if (item.length > 25 && sidebar) {
    return item.slice(0, 25) + "...";
  }
  return item;
};

const NavLinks = ({ sidebar, ctx, authenticated, auth }) => {
  const { t, i18n } = useTranslation();

  const menuActions = () => {
    ctx.toggleMenu(false);
  };

  return (
    <React.Fragment>
      {sidebar ? (
        <NavLink
          onClick={() => ctx.toggleMenu(false)}
          to={`/${i18n.language.slice(0, 2)}/`}
          className="logo logo-light"
        >
          <TendersClubLogo size="normal" colour="light" />
        </NavLink>
      ) : null}

      <NavLink
        onClick={() => menuActions()}
        to={`${i18n.language.slice(0, 2)}/pricing`}
        className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
      >
        {shortenItem(t("Pricing"), sidebar)}
      </NavLink>
      {authenticated && !window.location.pathname.includes("/services") ? (
        <TendersDropdown sidebar={sidebar} ctx={ctx} />
      ) : (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/search`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Search Tenders"), sidebar)}
        </NavLink>
      )}
      <NavLink
        onClick={() => menuActions()}
        to={`${i18n.language.slice(0, 2)}/contact`}
        className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
      >
        {shortenItem(t("Contact"), sidebar)}
      </NavLink>
      {authenticated ? null : (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/services`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("services"), sidebar)}
        </NavLink>
      )}
      <a
        href={`https://blog.tenders.club/${i18n.language.slice(0, 2)}`}
        className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        target="_blank"
        rel="noreferrer"
      >
        {shortenItem(t("Blog"), sidebar)}
      </a>
      {authenticated ? null : (
        <NavLink
          onClick={() => menuActions()}
          to={`/${i18n.language.slice(0, 2)}/login`}
          className={`menu-item ${!sidebar ? " ms-auto" : " menu-item-sidebar"} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Login"), sidebar)}
        </NavLink>
      )}
      {authenticated ? null : (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/register`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Register"), sidebar)}
        </NavLink>
      )}
      {authenticated && !window.location.pathname.includes("/services") && sidebar ? (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/user_preferences`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Settings"), sidebar)}
        </NavLink>
      ) : null}
      {authenticated && !window.location.pathname.includes("/services") ? (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/tender_strategy`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Tender Strategy"), sidebar)}
        </NavLink>
      ) : null}
      {useAuthStore.getState()?.user?.is_superuser && !window.location.pathname.includes("/services") && sidebar ? (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/admin/edit_tenders`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Edit Tenders"), sidebar)}
        </NavLink>
      ) : null}
      {useAuthStore.getState()?.user?.is_superuser && !window.location.pathname.includes("/services") && sidebar ? (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/admin/vademecum`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("Summary"), sidebar)}
        </NavLink>
      ) : null}
      {useAuthStore.getState()?.user?.is_superuser && !window.location.pathname.includes("/services") && sidebar ? (
        <NavLink
          onClick={() => menuActions()}
          to={`${i18n.language.slice(0, 2)}/admin/list_users`}
          className={`menu-item ${sidebar ? "menu-item-sidebar" : ""} ${i18n.language.slice(0, 2)}`}
        >
          {shortenItem(t("List Users"), sidebar)}
        </NavLink>
      ) : null}
    </React.Fragment>
  );
};
